module.exports = __webpack_public_path__ + "img/preloader.9a29d315.svg";